<template>
     <!-- bg-[#050508] -->
	<div class="w-full bg-black text-slate-200 selection:bg-blue-500/30 font-sans relative overflow-hidden">
		<!-- Ambient Glows -->
		<div class="absolute top-0 left-[-10%] w-[70vw] h-[70vw] md:w-[40vw] md:h-[40vw] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none z-0"></div>
		<div class="absolute bottom-0 right-[-10%] w-[70vw] h-[70vw] md:w-[40vw] md:h-[40vw] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none z-0"></div>
		<div class="w-full relative z-10">
			<div
				class="absolute top-0 -right-28 md:left-0 h-1/2 md:h-auto w-max md:w-full opacity-20 md:opacity-100 pointer-events-none"
			>
				<img
					class="h-1/2 md:w-full object-cover object-right"
					style="mask-image: linear-gradient(to right, transparent 0%, black 40%); -webkit-mask-image: linear-gradient(to right, transparent 0%, black 40%);"
					src="/promo/paydeck-cover-head-min.png"
				/>
			</div>
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="w-full mx-auto">
					<div class="font-bold text-white lg:pt-20">
						<div
							class="text-xl md:text-3xl xl:text-4xl 2xl:text-4xl font-extrabold uppercase tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-400 mb-2"
						>
							Don't Just Pay
						</div>
						<div
							class="mt-2 text-5xl md:text-7xl xl:text-8xl 2xl:text-8xl font-black uppercase tracking-tight text-white drop-shadow-2xl italic"
						>
							Outsmart Your <br />Payments
						</div>
					</div>
					<div
						class="text-xl xl:text-3xl text-slate-300 font-normal text-left pt-6 leading-relaxed max-w-2xl"
					>
						Pay All Your Education Expenses with Paydeck
					</div>
					<div
						class="text-lg xl:text-xl text-blue-300 font-bold tracking-wide uppercase text-left py-6"
					>
						Less Fees, More Convenience!
					</div>
					<div
						class="flex flex-wrap items-center justify-start gap-6"
					>
						<div class="flex flex-wrap items-center justify-start">
							<div
								class="h-[48px] w-[48px] rounded-full border-2 border-[#050508] ring-2 ring-blue-500/30"
							>
								<img
									src="/promo/p1.png"
									alt="avatar"
									class="h-full w-full rounded-full object-cover object-center"
								/>
							</div>
							<div
								class="-ml-4 h-[48px] w-[48px] rounded-full border-2 border-[#050508] ring-2 ring-blue-500/30"
							>
								<img
									src="/promo/p2.png"
									alt="avatar"
									class="h-full w-full rounded-full object-cover object-center"
								/>
							</div>
							<div
								class="-ml-4 h-[48px] w-[48px] rounded-full border-2 border-[#050508] ring-2 ring-blue-500/30"
							>
								<img
									src="/promo/p3.png"
									alt="avatar"
									class="h-full w-full rounded-full object-cover object-center"
								/>
							</div>
							<div
								class="-ml-4 h-[48px] w-[48px] rounded-full border-2 border-[#050508] ring-2 ring-blue-500/30"
							>
								<img
									src="/promo/p4.png"
									alt="avatar"
									class="h-full w-full rounded-full object-cover object-center"
								/>
							</div>
							<div
								class="-ml-4 h-[48px] w-[48px] rounded-full border-2 border-[#050508] ring-2 ring-blue-500/30"
							>
								<img
									src="/promo/p5.png"
									alt="avatar"
									class="h-full w-full rounded-full object-cover object-center"
								/>
							</div>
						</div>
						<div
							class="text-xl text-slate-400 font-medium"
						>
							Join 9.8L+ Indians who unlocked flexibility with
							Paydeck
						</div>
					</div>
					<div class="my-12 w-full">
						<div class="relative w-max">
							<a
								class="button w-max px-8 md:px-12 py-5 md:py-6 bg-blue-600 text-xl font-extrabold uppercase tracking-widest shadow-[0_10px_40px_rgba(37,99,235,0.4)] hover:shadow-[0_15px_60px_rgba(37,99,235,0.6)] text-white flex flex-row items-center justify-start gap-4 rounded-full transition-all duration-500 hover:scale-105 hover:bg-blue-500"
								href="https://app.paydeck.in/user/login"
								><img
									class="w-6"
									style="filter: brightness(0) invert(1)"
									src="/promo/p.png"
								/>
								Start Paying Now
							</a>
						</div>
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-3 justify-center gap-6 pt-6"
				>
					<div
						class="group relative overflow-hidden border border-white/10 px-12 py-8 bg-gradient-to-b from-white/[0.08] to-transparent hover:from-white/[0.12] rounded-3xl backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.5)] hover:shadow-[0_15px_40px_rgba(37,99,235,0.2)] transition-all duration-500 hover:border-blue-400/30 hover:-translate-y-2"
						v-for="(highlight, index) in paydeck_highlights"
						:key="'ph_' + index"
					>
						<div>
							<div
								class="flex flex-col lg:flex-row items-center h-full"
							>
								<img
									class="h-24 w-24 md:h-12 md:w-12 xl:h-20 xl:w-20 opacity-50"
									:src="highlight.image"
									style="filter: grayscale(1)"
								/>
								<div
									class="text-center lg:text-left mt-4 lg:mt-0 ml-0 lg:ml-4"
								>
									<div
										class="text-xl md:text-sm xl:text-md 2xl:text-xl font-medium xl:font-semibold text-white group-hover:text-blue-200 transition-colors duration-300"
										v-html="highlight.caption"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- ------------------ After Landing Page ------------------ -->
		<div class="w-full">
			<!-- ------------- After Simple Card ------------- -->
			<div class="container mx-auto link-sheet-2 text-left px-6 md:px-24 lg:px-36 pb-24">
				<div
					class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-12 p-12 md:p-16 border border-white/10 bg-white/[0.03] backdrop-blur-3xl rounded-[2.5rem] shadow-[0_8px_32px_rgba(0,0,0,0.5)] relative overflow-hidden"
				>
					<div
						v-for="(stat, si) in paydeck_stats"
						:key="'si+' + si"
						class="group"
					>
						<div
							class="text-5xl xl:text-6xl font-black pb-4 text-blue-400 drop-shadow-lg tracking-tighter"
						>
							{{ stat.value }}
						</div>
						<div
							class="text-lg 2xl:text-xl pr-6 font-medium text-slate-400 leading-relaxed group-hover:text-white transition-colors duration-300"
							v-html="stat.caption"
						></div>
					</div>
				</div>
			</div>
		</div>

		<!-- ==================== CARD PAYMENT USE CASES ==================== -->

		<!-- Section 1: Education & Academic Fees -->
		<div class="w-full flex flex-row items-center">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Education & Academic Fees
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Pay Your Academic Fees with Paydeck
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in educationFees"
						:key="'edu_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 2: Hostel & Accommodation -->
		<div class="w-full flex flex-row items-center relative">
			<div
				class="absolute top-0 -right-10 md:left-0 h-screen md:h-auto w-max md:w-full"
			>
				<img
					class="h-1/3 md:w-full"
					src="/promo/paydeck-cover-head-problems-min.png"
				/>
			</div>
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Hostel & Accommodation
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Never Miss a Hostel Payment Again
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in hostelFees"
						:key="'hostel_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 3: Coaching & Test Prep -->
		<div class="w-full flex flex-row items-center">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Coaching & Test Prep
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Invest in Learning, Pay from Paydeck
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in coachingFees"
						:key="'coaching_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 4: Transport & Shuttle -->
		<div class="w-full flex flex-row items-center relative">
			<div
				class="absolute top-0 -right-20 md:left-0 h-screen md:h-auto w-max md:w-full"
			>
				<img
					class="h-1/3 md:w-full"
					src="/promo/paydeck-cover-head-bbps-min.png"
				/>
			</div>
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Transport & Shuttle Fees
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Seamless Transport Payments
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in transportFees"
						:key="'transport_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 5: Library & Lab Fees -->
		<div class="w-full flex flex-row items-center">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Library, Lab & Supplies
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Every Campus Expense, One Platform
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in libraryLabFees"
						:key="'liblab_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 6: Extracurricular & Lifestyle -->
		<div class="w-full flex flex-row items-center">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Extracurricular & Lifestyle
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Empower Every Passion, Pay from Paydeck
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in extracurricularFees"
						:key="'extra_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div
								class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500"
							>
								<component
									:is="useCase.icon"
									class="w-7 h-7 text-blue-300"
									:stroke-width="1.5"
								/>
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 7: Freelancer & Professional
		<!--<div class="w-full flex flex-row items-center">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36"
			>
				<div class="font-bold text-white lg:pt-20">
					<div
						class="text-2xl md:text-4xl xl:text-4xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
					>
						Freelancer & Professional Fees
					</div>
					<div
						class="mt-4 text-4xl md:text-6xl xl:text-7xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						Pay Professionals With Your Card
					</div>
				</div>
				<div
					class="w-full grid grid-cols-1 md:grid-cols-2 gap-6 justify-center py-12"
				>
					<div
						v-for="(useCase, index) in freelancerFees"
						:key="'freelancer_' + index"
						class="group relative overflow-hidden bg-white/[0.02] hover:bg-white/[0.04] rounded-[2rem] h-full border border-white/10 hover:border-blue-400/30 shadow-2xl hover:shadow-[0_10px_40px_rgba(59,130,246,0.15)] transition-all duration-500 backdrop-blur-xl hover:-translate-y-2"
					>
						<div class="p-7 lg:p-9 xl:p-12">
							<div class="mb-6 w-14 h-14 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center shadow-[0_0_25px_rgba(59,130,246,0.2)] backdrop-blur-md group-hover:scale-110 transition-transform duration-500">
								<component :is="useCase.icon" class="w-7 h-7 text-blue-300" :stroke-width="1.5" />
							</div>
							<div
								class="text-2xl xl:text-3xl text-white font-extrabold text-left pb-3 pt-1 tracking-tight leading-snug group-hover:text-blue-100 transition-colors"
							>
								{{ useCase.title }}
							</div>
							<div
								class="text-lg xl:text-xl text-slate-400 font-normal text-left pb-2 leading-relaxed"
							>
								{{ useCase.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- ------------------ Payment Security - In Your Hands ------------------ -->
		<div class="w-full">
			<div
				class="container mx-auto link-sheet-20 px-6 pt-36 pb-12 md:p-24 lg:px-36 grid grid-cols-1 items-start justify-center gap-6"
			>
				<div
					class="max-w-4xl mx-auto flex flex-col items-center justify-center"
				>
					<div>
						<Vue3Lottie
							:animationData="ShieldJSON"
							:height="300"
							:width="300"
						/>
					</div>
					<div class="flex items-center justify-center gap-2">
						<div
							class="text-2xl text-center md:text-3xl font-bold tracking-widest uppercase text-blue-400 mb-2 drop-shadow-sm"
						>
							Backed by Trusted Banking Partners
						</div>
					</div>
					<div
						class="font-bold text-center mt-4 text-4xl md:text-6xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						A Verified Payment Processing System In Your Hands
					</div>
				</div>
				<div
					class="max-w-2xl mx-auto grid grid-cols-1 gap-6 justify-center py-12"
				>
					<div
						class="text-xl md:text-2xl text-white font-semibold pt-6"
					>
						At Paydeck, we advise you to focus on follow key
						security measures:
					</div>
					<div
						v-for="(security, i) in paydeck_security"
						:key="'security-1-' + i"
						class="flex flex-row items-start justify-start gap-4"
					>
						<CheckCircle
							class="w-6 h-6 text-blue-300 flex-shrink-0 mt-0.5"
						/>
						<div
							class="text-xl xl:text-2xl text-slate-400 font-medium text-left leading-relaxed"
						>
							{{ security }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ------------------ Ready to get started ------------------ -->
		<div class="w-full relative pb-24">
			<div
				class="absolute top-0 -right-20 md:left-0 h-screen md:h-auto w-max md:w-full"
			>
				<img
					class="h-1/3 md:w-full"
					src="/promo/paydeck-cover-head-amex-min.png"
				/>
			</div>
			<div
				class="container mx-auto link-sheet-20 px-6 h-screen flex flex-col items-center justify-center grid grid-cols-1 items-start justify-center gap-6"
			>
				<div
					class="w-full md:max-w-4xl mx-auto flex flex-col md:items-center justify-center"
				>
					<div
						class="w-max grid grid-cols-2 md:grid-cols-3 items-center justify-center"
					>
						<div class="mx-auto">
							<img class="w-16 md:w-24" src="/pg/visa.png" />
						</div>
						<div class="mx-auto">
							<img class="w-12 md:w-16" src="/pg/mastercard.png" />
						</div>
						<div class="mx-auto">
							<img class="w-20 md:w-32" src="/pg/rupay.png" />
						</div>
						<!-- <div class="mx-auto">
							<img class="w-12 md:w-20" src="/pg/amex.png" />
						</div> -->
					</div>
					<div
						class="font-bold text-2xl md:text-center md:text-3xl tracking-widest uppercase text-transparent bg-clip-text bg-gradient-to-r from-slate-200 to-slate-400 py-2"
					>
						Supports Popular Payment Enablers in India
					</div>
					<div
						class="font-bold md:text-center mt-4 text-4xl md:text-6xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300 drop-shadow-[0_10px_30px_rgba(255,255,255,0.05)] pb-2"
					>
						No rewards? Why use Paydeck?
					</div>
					<div
						class="font-semibold text-lg md:text-xl text-slate-300 py-12 capitalize flex flex-col items-start justify-start gap-2 md:gap-5"
					>
						<div class="flex items-center gap-3">
							<TrendingUp
								class="w-6 h-6 md:w-7 md:h-7 text-blue-300 flex-shrink-0"
							/>
							<span>Build your Credit History</span>
						</div>
						<div class="flex items-center gap-3">
							<Wallet
								class="w-6 h-6 md:w-7 md:h-7 text-blue-300 flex-shrink-0"
							/>
							<span>Make space for investments!</span>
						</div>
						<div class="flex items-center gap-3">
							<Clock
								class="w-6 h-6 md:w-7 md:h-7 text-blue-300 flex-shrink-0"
							/>
							<span>Avoid Late Fines</span>
						</div>
						<div class="flex items-center gap-3">
							<CheckCircle
								class="w-6 h-6 md:w-7 md:h-7 text-blue-300 flex-shrink-0"
							/>
							<span>Yes! We're RBI-compliant</span>
						</div>
						<div class="flex items-center gap-3">
							<Lock
								class="w-6 h-6 md:w-7 md:h-7 text-blue-300 flex-shrink-0"
							/>
							<span>We never store your card details</span>
						</div>
					</div>
					<div class="my-6 mx-auto">
						<a
							class="button w-max px-6 md:px-12 py-4 md:py-6 bg-blue-600 text-xl font-extrabold uppercase tracking-widest shadow-[0_10px_40px_rgba(37,99,235,0.4)] hover:shadow-[0_15px_60px_rgba(37,99,235,0.6)] text-white flex flex-row items-center justify-start gap-4 rounded-full transition-all duration-500 hover:scale-105 hover:bg-blue-500"
							href="https://app.paydeck.in/user/login"
							><img
								class="w-6"
								style="filter: brightness(0) invert(1)"
								src="/promo/p.png"
							/>
							Start a Payment Now!
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Vue3Lottie } from "vue3-lottie";
import ShieldJSON from "../assets/shield.json";
import {
	FileText,
	GraduationCap,
	Building2,
	Landmark,
	BookOpen,
	ClipboardCheck,
	PenLine,
	Monitor,
	Users,
	Home,
	CalendarDays,
	Lock,
	ClipboardList,
	UserRound,
	BookMarked,
	Bus,
	Navigation,
	Ticket,
	Library,
	BookX,
	Pencil,
	MapPin,
	Music,
	Trophy,
	FlaskConical,
	CheckCircle,
	TrendingUp,
	Wallet,
	Clock
} from "lucide-vue-next";

gsap.registerPlugin(ScrollTrigger);
export default {
	components: {
		Vue3Lottie,
		FileText,
		GraduationCap,
		Building2,
		Landmark,
		BookOpen,
		ClipboardCheck,
		PenLine,
		Monitor,
		Users,
		Home,
		CalendarDays,
		Lock,
		ClipboardList,
		UserRound,
		BookMarked,
		Bus,
		Navigation,
		Ticket,
		Library,
		BookX,
		Pencil,
		MapPin,
		Music,
		Trophy,
		FlaskConical,
		CheckCircle,
		TrendingUp,
		Wallet,
		Clock
	},
	metaInfo: {
		title: "Pay Education Fees from Paydeck | College, School, Hostel, Coaching & More | Paydeck.in",
		meta: [
			{
				name: "description",
				content:
					"Pay all education expenses from Paydeck — college fees, university tuition, school fees, hostel rent, coaching fees, entrance test fees, computer lab fees, library membership, school bus fees & more. Low fees, instant processing. Paydeck.in"
			},
			{
				name: "keywords",
				content:
					"pay college fees with credit card, pay university tuition fees with credit card, pay school fees with credit card, pay tuition fees with credit card, pay hostel fees with credit card, pay monthly hostel rent with credit card, security deposit mess accommodation credit card, pay coaching institute fees with credit card, pay test prep coaching fees with credit card, pay tuition teacher with credit card, ebook subscriptions credit card, pay college shuttle fees with credit card, pay school bus service fees with credit card, pay school shuttle with credit card, pay school bus booking with credit card, pay computer lab fees with credit card, pay library membership fees with credit card, pay overdue book fines with credit card, pay stationery academic supplies with credit card, pay school field trip fees with credit card, pay music dance art class fees with credit card, kids sports club fees credit card, science club fees credit card, pay college application fees credit card, pay entrance test fees credit card, pay exam registration fees credit card, online course platform payments credit card, pay alumni membership credit card, pay freelancer fees credit card, paydeck, education payment credit card India"
			}
		]
	},
	data() {
		return {
			ShieldJSON,
			// Section 1: Education & Academic Fees
			educationFees: [
				{
					icon: FileText,
					title: "College Application Fees",
					description:
						"Pay your college application fees instantly with Paydeck."
				},
				{
					icon: GraduationCap,
					title: "University Tuition Fees",
					description:
						"Cover university tuition payments seamlessly from Paydeck."
				},
				{
					icon: Building2,
					title: "College Fees",
					description:
						"Pay all college and university fees from Paydeck hassle free."
				},
				{
					icon: Landmark,
					title: "School Fees",
					description:
						"Pay your child's school fees conveniently with Paydeck."
				},
				{
					icon: BookOpen,
					title: "Tuition Fees",
					description:
						"Make tuition fee payments on time, every time from Paydeck."
				},
				{
					icon: ClipboardCheck,
					title: "Entrance Test Fees",
					description:
						"Pay entrance exam fees from Paydeck instantly."
				},
				{
					icon: PenLine,
					title: "Exam Registration Fees",
					description:
						"Register for exams by paying fees through Paydeck."
				},
				{
					icon: Monitor,
					title: "Online Course Platform Payments",
					description:
						"Subscribe to online learning platforms from Paydeck."
				},
				{
					icon: Users,
					title: "Pay For Alumni Membership",
					description:
						"Renew or purchase alumni association memberships with Paydeck."
				}
			],
			// Section 2: Hostel & Accommodation
			hostelFees: [
				{
					icon: Home,
					title: "Hostel Fees",
					description:
						"Pay hostel admission and semester fees with Paydeck."
				},
				{
					icon: CalendarDays,
					title: "Monthly Hostel Rent",
					description:
						"Never miss monthly hostel rent — pay with Paydeck."
				},
				{
					icon: Lock,
					title: "Security Deposit For Mess Accommodation",
					description:
						"Cover mess security deposits easily using Paydeck."
				}
			],
			// Section 3: Coaching & Test Prep
			coachingFees: [
				{
					icon: BookOpen,
					title: "Coaching Institute Payment",
					description:
						"Pay coaching institute fees seamlessly with Paydeck."
				},
				{
					icon: ClipboardList,
					title: "Test Prep Coaching Fees",
					description:
						"Invest in competitive exam prep — pay from Paydeck."
				},
				{
					icon: UserRound,
					title: "Pay For Tuition Teacher",
					description:
						"Pay your private tuition teacher using your Paydeck."
				},
				{
					icon: BookMarked,
					title: "eBook Subscriptions",
					description:
						"Subscribe to eBooks and digital learning resources with Paydeck."
				}
			],
			// Section 4: Transport & Shuttle
			transportFees: [
				{
					icon: Bus,
					title: "College Shuttle Fees",
					description:
						"Pay college shuttle service charges from Paydeck."
				},
				{
					icon: Bus,
					title: "School Bus Service Fees",
					description:
						"Cover school bus service fees easily from Paydeck."
				},
				{
					icon: Navigation,
					title: "Pay For School Shuttle",
					description: "Make school shuttle payments from Paydeck."
				},
				{
					icon: Ticket,
					title: "Pay For School Bus Booking",
					description:
						"Book and pay for school bus services with Paydeck."
				}
			],
			// Section 5: Library, Lab & Supplies
			libraryLabFees: [
				{
					icon: Monitor,
					title: "Computer Lab Fees",
					description: "Pay computer lab usage fees with Paydeck."
				},
				{
					icon: Library,
					title: "Library Membership Fees",
					description:
						"Renew library memberships instantly using Paydeck."
				},
				{
					icon: BookX,
					title: "Overdue Book Fines",
					description:
						"Clear overdue library fines conveniently with Paydeck."
				},
				{
					icon: Pencil,
					title: "Payment for Stationery and Academic Supplies",
					description:
						"Buy stationery and academic supplies using Paydeck."
				}
			],
			// Section 6: Extracurricular & Lifestyle
			extracurricularFees: [
				{
					icon: MapPin,
					title: "School Educational Field Trip Fees",
					description: "Pay field trip fees hassle-free with Paydeck."
				},
				{
					icon: Music,
					title: "Music Dance Art Class Fees",
					description:
						"Enrol in creative classes — pay tuition from Paydeck."
				},
				{
					icon: Trophy,
					title: "Kids Sports Club Fees",
					description:
						"Support your child's sports activities — pay with Paydeck."
				},
				{
					icon: FlaskConical,
					title: "Science Club Fees",
					description:
						"Pay science club membership and activity fees with Paydeck."
				}
			],
			// Section 7: Freelancer & Professional
			// freelancerFees: [
			// 	{
			// 		title: "Freelancer Fees",
			// 		description:
			// 			"Pay freelancers and independent professionals with your Paydeck."
			// 	}
			// ],
			paydeck_highlights: [
				{
					caption: "Connected With All Major Banks in India",
					image: require("@/assets/image/website/mejor-banks-in-india.svg")
				},
				{
					caption: "Maximum Fraud <br/>Prevention",
					image: require("@/assets/image/website/maximum-fraud-prevention.svg")
				},
				{
					caption: "More than 980K happy Customers",
					image: require("@/assets/image/website/happy-customers.svg")
				}
			],
			paydeck_stats: [
				{
					value: "₹44Bn+",
					caption: "Processed Transactions"
				},
				{
					value: "10+",
					caption: "Years Of Flawless Service In Fintech"
				},
				{
					value: "1st",
					caption:
						"India's First Card Based Payment Solution Provider"
				},
				{
					value: "9.8L+",
					caption: "Strong Family of Paydeck Users"
				}
			],
			paydeck_security: [
				"Never Share Your Debit Or Credit Card Details on Phone with anyone.",
				"Never Share Your Debit Or Credit Card CVV or OTP received on your mobile phone.",
				"Never reply to anyone claiming to be calling from a Bank or anywhere and providing you any help in doing a transaction",
				"Take a Walk to your nearest bank branch or call your Credit Card Or Debit card Helpline number when you feel suspicious.",
				"Payment Security is in your hands only, thus ensure to play safe!"
			]
		};
	},
	methods: {},
	mounted() {}
};
</script>

<style scoped>
.link-sheet-20 {
	width: 100%;
	z-index: 10 !important;
	overflow: hidden !important;
	position: relative;
}
.zero {
	background-size: 0%;
}
.span-color-4 {
	background-image: linear-gradient(#ff9680, #ffccde) !important;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-background-clip: text;
	-moz-text-fill-color: transparent;
}
.span-blue {
	color: #3913b8;
}
.span-blue-1 {
	color: #2249b3;
}
.span-white {
	color: rgba(255, 255, 255, 0.7);
}
.span-white-1 {
	color: rgba(255, 255, 255, 0.87);
}
.get-started-button {
	align-items: center;
	padding: 15px 33px;
	width: 197px;
	height: 54px;
	background: linear-gradient(91.96deg, #3913b8 0%, #ba75ff 100%);
	box-shadow: 0px 20px 40px rgba(113, 62, 215, 0.3);
	border-radius: 30px;
	transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.get-started-button:hover {
	transform: translateY(-5px);
	box-shadow: 0px 20px 40px rgba(113, 62, 215, 0.8);
}
.separate {
	bottom: 100px !important;
}

.payment-payout-background {
	background-image: linear-gradient(
		135.9deg,
		rgba(109, 25, 252, 1) 16.4%,
		rgba(125, 31, 165, 1) 56.1%
	);
	position: relative;
}
.limit-card {
	padding: 30px;
	background: rgba(88, 105, 255, 0.1);
	backdrop-filter: blur(30px);
	border-radius: 20px;
}
.simple-card {
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05),
		0px 10px 40px rgba(92, 103, 153, 0.3);
	border-radius: 30px;
	transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.simple-card:hover {
	transform: translateY(-5px);
	box-shadow: 10px 1px 3px rgba(0, 0, 0, 0.05),
		10px 20px 40px rgba(92, 103, 153, 0.2);
}
.roundedx-number {
	background: #dbe1ff;
	height: 30px !important;
	width: 30px;
	border-radius: 50%;
	text-align: center;
	padding: 5px;
}
.chip-background {
	background: rgba(0, 0, 0, 0.2);
	border-radius: 5px;
}
.start-now {
	position: relative;
	background: rgba(255, 255, 255, 0.9);
	box-shadow: 0px 20px 40px rgba(23, 0, 102, 0.3);
	border-radius: 30px;
	transition: 0.3s ease-in-out;
	width: 280px;
	cursor: pointer;
}
.start-now:hover {
	box-shadow: 0px 20px 40px rgba(23, 0, 102, 0.6);
	transform: translateY(-4px);
}

.paydeck-masthead-header {
}
.paydeck-masthead-image {
	margin-top: -30vh;
	height: 100vh;
	width: 120vw;
	max-width: unset;
	overflow: hidden !important;
}
/* Responsive Screen */
/* FOR 4K Displays */
@media only screen and (min-device-width: 2401px) and (max-device-width: 3300px) {
	.paydeck-masthead-image {
		margin-top: -60vh;
		width: 120vw;
		height: unset;
	}
}
/* FOR 2XL Displays */
@media only screen and (min-device-width: 2161px) and (max-device-width: 2400px) {
	.paydeck-masthead-image {
		margin-top: -70vh;
		width: 120vw;
		height: unset;
	}
}
/* FOR 2XL Displays */
@media only screen and (min-device-width: 1441px) and (max-device-width: 2160px) {
	.paydeck-masthead-image {
		margin-top: -42vh;
		width: 100vw;
		height: unset;
	}
}
/* FOR XL Displays */
@media only screen and (min-device-width: 1022px) and (max-device-width: 1440px) {
	.paydeck-masthead-image {
		margin-top: -16vh;
		width: 100vw;
		height: unset;
	}
}
/* FOR TABLET */
@media only screen and (max-device-width: 1024px) and (min-device-width: 768px) {
	.paydeck-masthead-image {
		width: 100%;
		height: auto;
		margin-top: 0vh;
		width: 100vw;
		height: unset;
	}
	.zero {
		background-size: 0%;
	}
}
/* FOR MOBILE */
@media only screen and (max-device-width: 767px) {
	.paydeck-masthead-image {
		opacity: 0;
	}
	.zero {
		background-position: left;
		background-repeat: no-repeat;
		background-size: cover;
		padding-bottom: 20vh;
		margin-bottom: 16vh;
	}
	.link-sheet-20 {
		width: 100%;
		z-index: 10 !important;
		overflow: hidden !important;
		position: relative;
	}
}

@keyframes flickerAnimation {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-o-keyframes flickerAnimation {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-moz-keyframes flickerAnimation {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-webkit-keyframes flickerAnimation {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
.animate-flicker {
	-webkit-animation: flickerAnimation 2s infinite;
	-moz-animation: flickerAnimation 2s infinite;
	-o-animation: flickerAnimation 2s infinite;
	animation: flickerAnimation 2s infinite;
}

@keyframes shine {
	0% {
		left: -100px;
	}
	20% {
		left: 100%;
	}
	100% {
		left: 100%;
	}
}

.button {
	position: relative;
	overflow: hidden;
}
.button::before {
	content: "";
	position: absolute;
	width: 100px;
	height: 100%;
	background-image: linear-gradient(
		120deg,
		rgba(255, 255, 255, 0) 30%,
		rgba(255, 255, 255, 0.4),
		rgba(255, 255, 255, 0) 70%
	);
	top: 0;
	left: -100px;
	animation: shine 3s infinite linear; /* Animation */
	pointer-events: none;
}
</style>
